
import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import Header from './components/Header';
import AboutUs from './components/AboutUs';
import WhatWeDo from './components/WhatWeDo';
import Careers from './components/Careers';
import ContactUs from './components/ContactUs';
import { SoundProvider } from './components/SoundManager';
import BackToTopButton from './components/BackToTopButton';

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]);
  const [inViewStates, setInViewStates] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Based on common mobile breakpoint
    };

    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setInViewStates((prev) => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting,
          }));
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  const setRef = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  return (
    <SoundProvider>
      <div className="App">
        <Header ref={setRef} inView={isMobile && inViewStates['header']} />
        <AboutUs ref={setRef} inView={isMobile && inViewStates['who-we-are']} />
        <WhatWeDo ref={setRef} inView={isMobile && inViewStates['what-we-do']} />
        <Careers ref={setRef} inView={isMobile && inViewStates['careers']} />
        <ContactUs ref={setRef} inView={isMobile && inViewStates['contact']} />
        <BackToTopButton />
      </div>
    </SoundProvider>
  );
}

export default App;
